import { GST, EPF, LEGAL, RATING, MCA, _NA, _1_TO_7_DAYS, _8_TO_15_DAYS, _NO_DELAY, _16_TO_30_DAYS,
     _31_TO_60_DAYS, _MORE_THAN_90_DAYS, _61_TO_90_DAYS, COMPANY_STATUS_ACTIVE, COMPANY_STATUS_INACTIVE, 
     COMPANY_COMPLIANCE_ACTIVE, COMPANY_NON_COMPLIANCE_ACTIVE, LEGAL_YES, LEGAL_NO, 
     AAA, AA, A, BBB, BB, B, C, D, ISSUER_NOT_COOPERATING, A1, A2, A3, A4 ,RATING_UPGRADED,RATING_DOWNGRADED,
     RATING_ISSUER_NOT_COR,RATING_NEW_RATED,RATING_NOT_RATED,RATING_NO_CHANGE,NOT_APPLICABLE,COMPANY_STATUS_DORRMANT_UNDER_SECTION,
     COMPANY_STATUS_ACTIVE_IN_PROGRESS,COMPANY_STATUS_AMALGAMATED,COMPANY_STATUS_NOT_AVAILABEL_FOR_EFILING,
     COMPANY_STATUS_CONVERTED_TO_LLP,COMPANY_STATUS_CONVERTED_TO_LLP_DISSOLVED,COMPANY_STATUS_DISSOLVED,
     COMPANY_STATUS_UNDER_LIQUIDATION,COMPANY_STATUS_LIQUIDATED,COMPANY_STATUS_UNDER_PROCESS_OF_STRICKING,
     COMPANY_STATUS_STRIKE_OFF,COMPANY_STATUS_DORMANT,COMPANY_STATUS_CAPTURED, _0_CASES, _1_TO_3_CASES,
    _4_TO_10_CASES, _MORE_THAN_10_CASES, EXTERNAL_CREDIT_RATING } from '../../constants';

import { toast } from 'react-toastify';
import React from 'react';

export const crawlerDataOptions = [
    { value: GST, label: GST },
    { value: EPF, label: EPF },
    { value: MCA, label: MCA },
    { value: LEGAL, label: LEGAL },
    { value: RATING, label: RATING }
];

export const prepareRatingGraphData = (name, data) => {
    let graphData = [['Value', name],
    [RATING_NOT_RATED, data["NOT_RATED"]],
    [NOT_APPLICABLE, data["NA"]],
    [RATING_DOWNGRADED, data["DOWNGRADED"]],
    [RATING_ISSUER_NOT_COR, data["ISSUER_NOT_COOPERATING"]],
    [RATING_NEW_RATED, data["NEWLY_RATED"]],
    [RATING_UPGRADED, data["UPGRADED"]],
    [RATING_NO_CHANGE, data["NO_CHANGE"]],
    ];
    return graphData;
}

export const prepareRatingData = (data, value) => {
    if (value && value.trim().toUpperCase() == RATING_UPGRADED.trim().toUpperCase()) {
        data["UPGRADED"] = data["UPGRADED"] + 1;
    } else if (value && value.trim().toUpperCase() == RATING_DOWNGRADED.trim().toUpperCase()) {
        data["DOWNGRADED"] = data["DOWNGRADED"] + 1;
    }
    else if (value && value.trim().toUpperCase() == RATING_ISSUER_NOT_COR.trim().toUpperCase()) {
        data["ISSUER_NOT_COOPERATING"] = data["ISSUER_NOT_COOPERATING"] + 1;
    }
    else if (value && value.trim().toUpperCase() == RATING_NEW_RATED.trim().toUpperCase()) {
        data["NEWLY_RATED"] = data["NEWLY_RATED"] + 1;
    }
    else if (value && value.trim().toUpperCase() == RATING_NO_CHANGE.trim().toUpperCase()) {
        data["NO_CHANGE"] = data["NO_CHANGE"] + 1;
    }
    else if (value && value.trim().toUpperCase() == RATING_NOT_RATED.trim().toUpperCase()) {
        data["NOT_RATED"] = data["NOT_RATED"] + 1;
    }
    else if (value && value.trim().toUpperCase() == "NA") {
        data["NA"] = data["NA"] + 1;
    }
    else{
        console.log("No Match found");
    }
   
    return data;
}

export const prepareLegalGraphData = (name, data) => {
    let graphData = [['Value', name],
    [LEGAL_YES, data[LEGAL_YES]],
    [LEGAL_NO, data[LEGAL_NO]],
    ];
    return graphData;
}

export const prepareLegalData = (data, value) => {
    if (value && value.trim().toUpperCase() == LEGAL_YES.trim().toUpperCase()) {
        data[LEGAL_YES] = data[LEGAL_YES] + 1;
    } else if (value && value.trim().toUpperCase() == LEGAL_NO.trim().toUpperCase()) {
        data[LEGAL_NO] = data[LEGAL_NO] + 1;
    }
    return data;
}

export const prepareLegalCourtCasesGraphData = (name,data) => {
    let graphData = [['Value', name],
    [_0_CASES, data["_0_CASES"]],
    [_1_TO_3_CASES, data["_1_TO_3_CASES"]],
    [_4_TO_10_CASES, data["_4_TO_10_CASES"]],
    [_MORE_THAN_10_CASES, data["_MORE_THAN_10_CASES"]],
    ];
    return graphData;
}

export const prepareLegalCourtCasesData = (data,value) => {
    if (value != null) {
        if (value == 0){
            data["_0_CASES"] = data["_0_CASES"] + 1;
        } 
        else if (value > 0 && value <= 3) {
            data["_1_TO_3_CASES"] = data["_1_TO_3_CASES"] + 1;
        }
        else if (value > 3 && value <= 10) {
            data["_4_TO_10_CASES"] = data["_4_TO_10_CASES"] + 1;
        }
        else if (value > 10) {
            data["_MORE_THAN_10_CASES"] = data["_MORE_THAN_10_CASES"] + 1;
        }
    }
    return data;
}

export const prepareCompanyBalanceSheetDateGraphData = (graphName, data) => {
    let keys = Object.keys(data);
    let graphData = [["Dates", graphName]];
    keys.forEach(obj => {
        if(obj=="_NA" || obj=="NOT_APPLICABLE_OR_AVAILABLE" || obj=="NA" ){
            graphData.push([NOT_APPLICABLE, data[obj]]);
        }
        else{
            graphData.push([obj, data[obj]]);
        }
        
        //}

    })
    return graphData;
}

export const prepareCompanyBalanceSheetDateData = (companyData, date) => {
    if (!date || (date && date.trim() === "" || date.trim() == "-" || date.trim() == "NA" || date.trim().toLowerCase() == "not applicable")) {
        companyData["NA"] = (companyData["NA"] !== undefined || companyData["NA"] >= 0) ? companyData["NA"] + 1 : 0;
    } else if (companyData[date] && companyData[date] > 0) {
        companyData[date] = companyData[date] + 1;
    } else {
        companyData[date] = 1;
    }
    return companyData;
}

export const getScoreFromObj = (obj, value) => {
    switch (value) {
        case EPF:
            return obj.epfScore;
        case GST:
            return obj.gstScore;
        case MCA:
            return obj.mcaScore;
        case RATING:
            return obj.ratingScore;
        case LEGAL:
            return obj.legalScore;
        default:
            return "";
    }
}

export const prepareDelayData = (avgDelayData, delay) => {
    if ((!delay && delay != 0)|| (delay && delay != "" && delay == "NA")) {
        avgDelayData["_NA"] = avgDelayData["_NA"] + 1;
    } else if (delay == 0 ) {
        avgDelayData["_NO_DELAY"] = avgDelayData["_NO_DELAY"] + 1;
    } else if (delay && delay != "" && delay < 8) {
        avgDelayData["_1_TO_7_DAYS"] = avgDelayData["_1_TO_7_DAYS"] + 1;
    } else if (delay && delay != "" && delay < 16) {
        avgDelayData["_8_TO_15_DAYS"] = avgDelayData["_8_TO_15_DAYS"] + 1;
    } else if (delay && delay != "" && delay < 31) {
        avgDelayData["_16_TO_30_DAYS"] = avgDelayData["_16_TO_30_DAYS"] + 1;
    } else if (delay && delay != "" && delay < 61) {
        avgDelayData["_31_TO_60_DAYS"] = avgDelayData["_31_TO_60_DAYS"] + 1;
    } else if (delay && delay != "" && delay < 91) {
        avgDelayData["_61_TO_90_DAYS"] = avgDelayData["_61_TO_90_DAYS"] + 1;
    } else if (delay && delay != "" && delay > 90) {
        avgDelayData["_MORE_THAN_90_DAYS"] = avgDelayData["_MORE_THAN_90_DAYS"] + 1;
    }
    return avgDelayData;
}

export const prepareScoreData = (scoreData, score, crawler) => {
    switch (crawler) {
        case LEGAL: crawler = 'Legal'; break;
        case RATING: crawler = EXTERNAL_CREDIT_RATING; break;
    }
    if (score && score != "NA" && score != "" && score >= 75) {
        if (crawler != EXTERNAL_CREDIT_RATING){
            scoreData[crawler + "CRAWLER_COM_SCORE_GREATER_THAN_75"] = scoreData[crawler + "CRAWLER_COM_SCORE_GREATER_THAN_75"] + 1;
        } else {
            scoreData[crawler + "EXTERNAL_RATING_SCORE_GREATER_THAN_75"] = scoreData[crawler + "EXTERNAL_RATING_SCORE_GREATER_THAN_75"] + 1;
        }
       
    } else if (score && score != "NA" && score != "" && score >= 50) {
        scoreData["GREATER_THAN_OR_EQUAL_TO_50"] = scoreData["GREATER_THAN_OR_EQUAL_TO_50"] + 1;
    } else if (score != undefined && (score == 0 || (score != "NA" && score != "" && score >= 0))) {
        scoreData["LESS_THAN_50"] = scoreData["LESS_THAN_50"] + 1;
    } else {
        scoreData["NOT_APPLICABLE_OR_AVAILABLE"] = scoreData["NOT_APPLICABLE_OR_AVAILABLE"] + 1;
    }
    return scoreData;
}


export const prepareComapnyComplianceData = (companyData, compliance) => {
        if (!compliance || compliance == "0" || (compliance && compliance.trim() === "" || compliance.trim() == "-" || compliance.trim() == "NA" || compliance.trim() == NOT_APPLICABLE)) {
            companyData["_NA"] = companyData["_NA"] + 1 ;
        } else if (compliance && compliance.trim().toUpperCase() == COMPANY_COMPLIANCE_ACTIVE.trim().toUpperCase()){
            companyData["COMPANY_COMPLIANCE_ACTIVE"] = companyData["COMPANY_COMPLIANCE_ACTIVE"] + 1;
        } else if (compliance && compliance.trim().toUpperCase() == COMPANY_NON_COMPLIANCE_ACTIVE.trim().toUpperCase()){
            companyData["COMPANY_NON_COMPLIANCE_ACTIVE"] = companyData["COMPANY_NON_COMPLIANCE_ACTIVE"] + 1;
        }
        else{
            console.log("no match found");
        }
        return companyData;
    }

export const prepareCompanyComplianceGraphData = (graphName, data) => {

    let graphData = [['Status Data', graphName],
    [COMPANY_COMPLIANCE_ACTIVE, data["COMPANY_COMPLIANCE_ACTIVE"]],
    [COMPANY_NON_COMPLIANCE_ACTIVE, data["COMPANY_NON_COMPLIANCE_ACTIVE"]],
    [NOT_APPLICABLE, data["_NA"]],
    ];
    return graphData;
}

export const prepareCompanyStatusGraphData = (graphName, data) => {
    let graphData = [['Value', graphName],
    [NOT_APPLICABLE, data["NOT_APPLICABLE"]],
    [COMPANY_STATUS_ACTIVE, data["COMPANY_STATUS_ACTIVE"]],
    [COMPANY_STATUS_INACTIVE, data["COMPANY_STATUS_INACTIVE"]],
    [COMPANY_STATUS_DORMANT, data["DORMANT"]],
    [COMPANY_STATUS_DORRMANT_UNDER_SECTION, data["DORMANT_UNDER_SECTION_455"]],
    [COMPANY_STATUS_ACTIVE_IN_PROGRESS, data["ACTIVE_IN_PROGRESS"]],
    [COMPANY_STATUS_AMALGAMATED, data["AMALGAMATED"]],
    [COMPANY_STATUS_NOT_AVAILABEL_FOR_EFILING, data["NOT_AVAILABLE_FOR_EFILING"]],
    [COMPANY_STATUS_CONVERTED_TO_LLP, data["CONVERTED_TO_LLP"]],
    [COMPANY_STATUS_CONVERTED_TO_LLP_DISSOLVED, data["CONVERTED_TO_LLP_DISSOLVED"]],
    [COMPANY_STATUS_DISSOLVED, data["DISSOLVED"]],
    [COMPANY_STATUS_UNDER_LIQUIDATION, data["UNDER_LIQUIDATION"]],
    [COMPANY_STATUS_LIQUIDATED, data["LIQUIDATED"]],
    [COMPANY_STATUS_UNDER_PROCESS_OF_STRICKING, data["UNDER_PROCESS_OF_STRIKING_OFF"]],
    [COMPANY_STATUS_STRIKE_OFF, data["STRIKE_OFF"]],
    [COMPANY_STATUS_CAPTURED, data["CAPTURED"]],
    ];
    return graphData;
    
}

export const prepareCompanyStatusData = (companyData, status) => {
    if (!status || (status && status.trim() === "" || status.trim() == "-" || status.trim() == _NA || status.trim() == NOT_APPLICABLE)) {
        companyData["NOT_APPLICABLE"] = companyData["NOT_APPLICABLE"] + 1 ;
    }
    else if (status && status.trim().toUpperCase() == COMPANY_STATUS_ACTIVE.trim().toUpperCase()) {
        companyData["COMPANY_STATUS_ACTIVE"] = companyData["COMPANY_STATUS_ACTIVE"] + 1;
    }
    else if (status && status.trim().toUpperCase() == COMPANY_STATUS_INACTIVE.trim().toUpperCase()) {
        companyData["COMPANY_STATUS_INACTIVE"] = companyData["COMPANY_STATUS_INACTIVE"] + 1;
    }
    else if (status && status.trim().toUpperCase() == COMPANY_STATUS_DORMANT.trim().toUpperCase()) {
        companyData["DORMANT"] = companyData["DORMANT"] + 1;
    }
    else if (status && status.trim().toUpperCase() == COMPANY_STATUS_DORRMANT_UNDER_SECTION.trim().toUpperCase()) {
        companyData["DORMANT_UNDER_SECTION_455"] = companyData["DORMANT_UNDER_SECTION_455"] + 1;
    }
    else if (status && status.trim().toUpperCase() == COMPANY_STATUS_ACTIVE_IN_PROGRESS.trim().toUpperCase()) {
        companyData["ACTIVE_IN_PROGRESS"] = companyData["ACTIVE_IN_PROGRESS"] + 1;
    }
    else if (status && status.trim().toUpperCase() == COMPANY_STATUS_AMALGAMATED.trim().toUpperCase()) {
        companyData["AMALGAMATED"] = companyData["AMALGAMATED"] + 1;
    }
    else if (status && status.trim().toUpperCase() == COMPANY_STATUS_NOT_AVAILABEL_FOR_EFILING.trim().toUpperCase()) {
        companyData["NOT_AVAILABLE_FOR_EFILING"] = companyData["NOT_AVAILABLE_FOR_EFILING"] + 1;
    }
    else if (status && status.trim().toUpperCase() == COMPANY_STATUS_CONVERTED_TO_LLP.trim().toUpperCase()) {
        companyData["CONVERTED_TO_LLP"] = companyData["CONVERTED_TO_LLP"] + 1;
    }
    else if (status && status.trim().toUpperCase() == COMPANY_STATUS_CONVERTED_TO_LLP_DISSOLVED.trim().toUpperCase()) {
        companyData["CONVERTED_TO_LLP_DISSOLVED"] = companyData["CONVERTED_TO_LLP_DISSOLVED"] + 1;
    }
    else if (status && status.trim().toUpperCase() == COMPANY_STATUS_DISSOLVED.trim().toUpperCase()) {
        companyData["DISSOLVED"] = companyData["DISSOLVED"] + 1;
    }
    else if (status && status.trim().toUpperCase() == COMPANY_STATUS_UNDER_LIQUIDATION.trim().toUpperCase()) {
        companyData["UNDER_LIQUIDATION"] = companyData["UNDER_LIQUIDATION"] + 1;
    }
    else if (status && status.trim().toUpperCase() == COMPANY_STATUS_LIQUIDATED.trim().toUpperCase()) {
        companyData["LIQUIDATED"] = companyData["LIQUIDATED"] + 1;
    }
    else if (status && status.trim().toUpperCase() == COMPANY_STATUS_UNDER_PROCESS_OF_STRICKING.trim().toUpperCase()) {
        companyData["UNDER_PROCESS_OF_STRIKING_OFF"] = companyData["UNDER_PROCESS_OF_STRIKING_OFF"] + 1;
    }
    else if (status && status.trim().toUpperCase() == COMPANY_STATUS_STRIKE_OFF.trim().toUpperCase()) {
        companyData["STRIKE_OFF"] = companyData["STRIKE_OFF"] + 1;
    }
    else if (status && status.trim().toUpperCase() == COMPANY_STATUS_CAPTURED.trim().toUpperCase()) {
        companyData["CAPTURED"] = companyData["CAPTURED"] + 1;
    }
    else{
        console.log("Not match Found")
    }
    
    return companyData;
}
    

export const prepareDelayGraphData = (graphName, delayData) => {
    let delayGraphData = [['Range of Days', graphName],
    [_NO_DELAY, delayData["_NO_DELAY"]],
    [_1_TO_7_DAYS, delayData["_1_TO_7_DAYS"]],
    [_8_TO_15_DAYS, delayData["_8_TO_15_DAYS"]],
    [_16_TO_30_DAYS, delayData["_16_TO_30_DAYS"]],
    [_31_TO_60_DAYS, delayData["_31_TO_60_DAYS"]],
    [_61_TO_90_DAYS, delayData["_61_TO_90_DAYS"]],
    [_MORE_THAN_90_DAYS, delayData["_MORE_THAN_90_DAYS"]],
    [NOT_APPLICABLE, delayData["_NA"]]
    ];
    return delayGraphData;
}

export const prepareLongTermRatingData = (data, value, status) => {
    if (value && value.trim().length > 0) {
        let rating = value.replace("+", "").replace("-", "").toUpperCase();
        if (status && status.toUpperCase() === ISSUER_NOT_COOPERATING.toUpperCase()) {
            data[ISSUER_NOT_COOPERATING] = data[ISSUER_NOT_COOPERATING] + 1;
            return data;
        }
        if(rating && rating === NOT_APPLICABLE.toUpperCase()){
            data[NOT_APPLICABLE] = data[NOT_APPLICABLE] + 1;
            return data;
        }
        switch (rating) {
            case AAA:
                data[AAA] = data[AAA] + 1;
                break;
            case AA:
                data[AA] = data[AA] + 1;
                break;
            case A:
                data[A] = data[A] + 1;
                break;

            case BBB:
                data[BBB] = data[BBB] + 1;
                break;

            case BBB:
                data[BBB] = data[BBB] + 1;
                break;
            case BB:
                data[BB] = data[BB] + 1;
                break;
            case B:
                data[B] = data[B] + 1;
                break;
            case C:
                data[C] = data[C] + 1;
                break;

            case D:
                data[D] = data[D] + 1;
                break;
            case A1:
                data[A1] = data[A1] + 1;
                break;
            case A2:
                data[A2] = data[A2] + 1;
                break;
            case A3:
                data[A3] = data[A3] + 1;
                break;
            case A4:
                data[A4] = data[A4] + 1;
                break;
            default: break;
        }
    }
    return data;
}


export const prepareGraphData = (data, graphName) => {
    let keys = Object.keys(data);
    let graphData = [["Rating", graphName]];
    keys.map(obj => {
        if(obj=="_NA" || obj=="NOT_APPLICABLE_OR_AVAILABLE" || obj=="NA" || obj=="NOT_APPLICABLE" ){
            graphData.push([NOT_APPLICABLE, data[obj]]);
        }
        else{
            graphData.push([obj, data[obj]]);
        }
        
    })
    return graphData;
}

export const prepareStatusData = (data, value) => {
    if(value && data && value.trim().length > 0 ){
        if(data[value] ){
            data[value] = data[value] + 1;
        }else{
            data[value] = 1;
        }
    }
    return data;
}

export const displaySuccessMessage = (message) => (
    toast.success(
        <div>
            <i ></i>&nbsp; {message}
        </div>
    )
);

export const displayErrorMessage = (message) => (
    toast.error(
        <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp; {message}
        </div>
    )
);